import BaseSwal from "sweetalert2";

// SweetAlert2's default z-index (1060) sits below MUI's Dialog/Modal
// (1300) — firing a confirmation while an "Tambah/Edit ..." Dialog is still
// open (the normal pattern across this app) rendered the confirmation
// behind the Dialog's backdrop, invisible. Push it above every MUI layer
// (tooltip, the highest default, is 1500) so it's never obscured.
const style = document.createElement("style");
style.textContent = `.swal2-container { z-index: 2000 !important; }`;
document.head.appendChild(style);

// Central Swal instance so every dialog in the app shares one config.
// scrollbarPadding:false stops SweetAlert2 from compensating for the hidden
// scrollbar with body padding — that padding was shrinking our fixed-width
// AppBar/sidebar layout and showing up as a white gutter on the right.
const Swal = BaseSwal.mixin({ scrollbarPadding: false });

export default Swal;
